module.exports = __webpack_public_path__ + "fonts/Nunito-Bold.bafb48d6.woff2";